import React from 'react';
import {AdvancedMarker} from '@vis.gl/react-google-maps';
import styles from '../mapping/Mapping.module.css';

const NutrientRemovalMarker = ({farmField}) => {

  return (
    <>
      <AdvancedMarker
        position={{
          lng: farmField.Longitude,
          lat: farmField.Latitude
        }}
        key={farmField.FieldId}>
        <div className={styles.nutrientRemovalWidget}>
          <div className={styles.farmFieldName}>
            {farmField.FarmName}
          </div>
          <hr className={styles.separator} />
          <div className={styles.nutrientRemovalRow}>
            <div className={styles.fieldInfoBold} style={{width: 100}}>
              Crop Year
            </div>
            <div className={styles.fieldInfo} style={{width: 75}}>
              {farmField.CropYearCurrent ? farmField.CropYearCurrent : 'N/A'}
            </div>
            <div className={styles.fieldInfo} style={{width: 75}}>
              &nbsp;
            </div>
            <div className={styles.fieldInfo} style={{width: 75}}>
              {farmField.CropYearPrevious ? farmField.CropYearPrevious : 'N/A'}
            </div>
            <div className={styles.fieldInfo} style={{width: 75}}>
              &nbsp;
            </div>
            <div className={styles.fieldInfo} style={{width: 120}}>
              &nbsp;
            </div>
          </div>
          <div className={styles.nutrientRemovalRow}>
            <div className={styles.fieldInfoBold} style={{width: 100}}>
              Commodity
            </div>
            <div className={styles.fieldInfo} style={{width: 75}}>
              {farmField.CommodityCurrent ? farmField.CommodityCurrent : 'N/A'}
            </div>
            <div className={styles.fieldInfo} style={{width: 75}}>
              &nbsp;
            </div>
            <div className={styles.fieldInfo} style={{width: 75}}>
              {farmField.CommodityPrevious ? farmField.CommodityPrevious : 'N/A'}
            </div>
            <div className={styles.fieldInfo} style={{width: 75}}>
              &nbsp;
            </div>
            <div className={styles.fieldInfo} style={{width: 120}}>
              &nbsp;
            </div>
          </div>
          <div className={styles.nutrientRemovalRow}>
            <div className={styles.fieldInfoBold} style={{width: 100}}>
              Yield
            </div>
            <div className={styles.fieldInfo} style={{width: 75}}>
              {
                isNaN(farmField.TotalNetUnitsCurrent) ?
                'N/A' :
                Number(farmField.TotalNetUnitsCurrent).toLocaleString('en-US', {style: 'decimal', maximumFractionDigits: 2, minimumFractionDigits: 2,})
              }
            </div>
            <div className={styles.fieldInfo} style={{width: 75}}>
              &nbsp;
            </div>
            <div className={styles.fieldInfo} style={{width: 75}}>
              {
                isNaN(farmField.TotalNetUnitsPrevious) ?
                'N/A' :
                Number(farmField.TotalNetUnitsPrevious).toLocaleString('en-US', {style: 'decimal', maximumFractionDigits: 2, minimumFractionDigits: 2,})
              }
            </div>
            <div className={styles.fieldInfo} style={{width: 75}}>
              &nbsp;
            </div>
            <div className={styles.fieldInfo} style={{width: 120}}>
              &nbsp;
            </div>
          </div>
          <hr className={styles.separator} />
          <div className={styles.nutrientRemovalRow}>
            <div className={styles.fieldInfoBold} style={{width: 100}}>
              Removal
            </div>
            <div className={styles.fieldInfo} style={{width: 75}}>
              &nbsp;
            </div>
            <div className={styles.fieldInfo} style={{width: 75}}>
              &nbsp;
            </div>
            <div className={styles.fieldInfo} style={{width: 75}}>
              &nbsp;
            </div>
            <div className={styles.fieldInfo} style={{width: 75}}>
              &nbsp;
            </div>
            <div className={styles.fieldInfoBoldRightJustified} style={{width: 120}}>
              2 Year Removal
            </div>
          </div>
          <div className={styles.nutrientRemovalRow}>
            <div className={styles.fieldInfoBold} style={{width: 100}}>
              Potash
            </div>
            <div className={styles.fieldInfo} style={{width: 75}}>
              {
                isNaN(farmField.PotashNutrientRemovalCurrent) ?
                'N/A' :
                Number(farmField.PotashNutrientRemovalCurrent).toLocaleString('en-US', {style: 'decimal', maximumFractionDigits: 2, minimumFractionDigits: 2,})
              }
            </div>
            <div className={styles.fieldInfo} style={{width: 75}}>
              +
            </div>
            <div className={styles.fieldInfo} style={{width: 75}}>
              {
                isNaN(farmField.PotashNutrientRemovalPrevious) ?
                'N/A' :
                Number(farmField.PotashNutrientRemovalPrevious).toLocaleString('en-US', {style: 'decimal', maximumFractionDigits: 2, minimumFractionDigits: 2,})
              }
            </div>
            <div className={styles.fieldInfo} style={{width: 75}}>
              =
            </div>
            <div className={styles.fieldInfo} style={{width: 120}}>
              {
                isNaN(farmField.PotashNutrientRemovalCurrent) || isNaN(farmField.PotashNutrientRemovalPrevious) ?
                'N/A' :
                Number(farmField.PotashNutrientRemovalCurrent + farmField.PotashNutrientRemovalPrevious).toLocaleString('en-US', {style: 'decimal', maximumFractionDigits: 2, minimumFractionDigits: 2,})
              }
            </div>
          </div>
          <div className={styles.nutrientRemovalRow}>
            <div className={styles.fieldInfoBold} style={{width: 100}}>
              MAP
            </div>
            <div className={styles.fieldInfo} style={{width: 75}}>
              {
                isNaN(farmField.MapNutrientRemovalCurrent) ?
                'N/A' :
                Number(farmField.MapNutrientRemovalCurrent).toLocaleString('en-US', {style: 'decimal', maximumFractionDigits: 2, minimumFractionDigits: 2,})
              }
            </div>
            <div className={styles.fieldInfo} style={{width: 75}}>
              +
            </div>
            <div className={styles.fieldInfo} style={{width: 75}}>
              {
                isNaN(farmField.MapNutrientRemovalPrevious) ?
                'N/A' :
                Number(farmField.MapNutrientRemovalPrevious).toLocaleString('en-US', {style: 'decimal', maximumFractionDigits: 2, minimumFractionDigits: 2,})
              }
            </div>
            <div className={styles.fieldInfo} style={{width: 75}}>
              =
            </div>
            <div className={styles.fieldInfo} style={{width: 120}}>
              {
                isNaN(farmField.MapNutrientRemovalCurrent) || isNaN(farmField.MapNutrientRemovalPrevious) ?
                'N/A' :
                Number(farmField.MapNutrientRemovalCurrent + farmField.MapNutrientRemovalPrevious).toLocaleString('en-US', {style: 'decimal', maximumFractionDigits: 2, minimumFractionDigits: 2,})
              }
            </div>
          </div>
          <hr className={styles.separator} />
          <div className={styles.fieldInfo}>
          </div>
          <div className={styles.arrow}>&#x25BC;</div>
        </div>
      </AdvancedMarker>
    </>
  );
};

export default NutrientRemovalMarker;